import Vue from 'vue';
import VueRouter from 'vue-router';
import Editor from '../views/Editor.vue';
import Articles from '../views/Articles.vue';
import Users from '../views/Users.vue';
import Media from '../views/Media.vue';
import VideoProcessing from '../views/VideoProcessing.vue';
import Embed from '../views/Embed.vue';
import Signin from '../views/Signin.vue';
import Account from '../views/Account.vue';
import AmwayStore from '../views/AmwayStore.vue';
import Bodykey from '../views/Bodykey.vue';
import PageEditor from '../views/PageEditor.vue';
import Settings from '../views/Settings.vue';
import NutriliteRecommender from '../views/NutriliteRecommender.vue';
import ResepSehat from '../views/ResepSehat.vue';
import TesLelah from '../views/TesLelah.vue';
import Home from '../views/Home.vue';
import Slider from '../views/Slider.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/article/editor',
    name: 'editor',
    component: Editor,
  },
  {
    path: '/article/:slug',
    name: 'articles',
    component: Articles,
  },
  {
    path: '/users/:role',
    name: 'users',
    component: Users,
  },
  {
    path: '/media/all',
    name: 'media',
    component: Media,
  },
  {
    path: '/homepage/banner',
    name: 'banner',
    component: Slider,
  },
  {
    path: '/media/detail/:id',
    name: 'mediaDetail',
    component: VideoProcessing,
  },
  {
    path: '/media/embed/:id',
    name: 'embed',
    component: Embed,
  },
  {
    path: '/signin',
    name: 'signin',
    component: Signin,
  },
  {
    path: '/user/account',
    name: 'account',
    component: Account,
  },
  {
    path: '/amway-store',
    name: 'amwayStore',
    component: AmwayStore,
  },
  {
    path: '/bodykey/landing-page',
    name: 'bodykey',
    component: Bodykey,
  },
  {
    path: '/page/editor/:slug',
    name: 'pageEditor',
    component: PageEditor,
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
  },
  {
    path: '/user-content/nutrilite-recommender',
    name: 'nutriliteRecommender',
    component: NutriliteRecommender,
  },
  {
    path: '/user-content/kompetisi-resep-sehat',
    name: 'resepSehat',
    component: ResepSehat,
  },
  {
    path: '/user-content/tes-lelah',
    name: 'tesLelah',
    component: TesLelah,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { app }: any = router;
  if (to.fullPath === '/signin') {
    if (app.$session.exists()) {
      next(process.env.BASE_URL);
      return;
    }
  } else if (!app.$session.exists()) {
    next('/signin');
    return;
  }
  next();
});

export default router;
